import React from 'react';
import burgerIcon from '../../../assets/foodfight_burger.png';
import glovesIcon from '../../../assets/foodfight_gloves.png';
import logoIcon from '../../../assets/foodfight_red_primary_05_downsized.png';

import '../../../styles/fight/challenger/FighterTile.scss';

/**
 * Simple component representing a single tile in the fighter selection grid.
 * @param {Object} props
 * @param {Object} props.fighter The fighter to display in the tile.
 * @param {boolean} props.selected Whether the tile is selected. If selected the tile will special styling to indicate so.
 * @param {Function} props.onClick The function to call when the tile is clicked.
 * @returns
 */
function FighterTile({ fighter, selected, onClick, iconIndex }) {
  const { name } = fighter;
  const icons = [burgerIcon, logoIcon, glovesIcon];
  const selectedIcon = icons[iconIndex % icons.length]; // Select icon based on index

  const displayFormattedName = () => {
    const parts = name.split(' ');
    if (parts.length > 1) {
      return `${parts[0]} ${parts[1][0]}.`;
    }
    return `${name}`;
  };

  const formattedName = displayFormattedName();

  return (
    <div
      className={`fighter-tile${selected ? ' selected' : ''}`}
      role='button'
      tabIndex={0}
      onClick={event => {
        onClick(event, selectedIcon);
      }}>
      <img src={selectedIcon} alt='icon' className='icon-img' />
      <div className='fighter-details-wrap'>
        <p className='fighter-name'>
          {formattedName} <span className='fighter-username'>| @{fighter.username}</span>
        </p>
        <div className='fighter-stat'>
          <p className='fighter-user-info'>
            Win {fighter.wins} - Lose {fighter.losses} - Tie {fighter.ties}
          </p>
        </div>
      </div>
    </div>
  );
}

export default FighterTile;
